import React from 'react'
import { withTranslation, useTranslation } from 'react-i18next'

import Typography from '../../../components/atoms/display/typography'

import useStyles from './metricStyle'

const Metric = (props) => {
  const { t } = useTranslation()

  let useStylesParams = {
    status: props?.status,
    large: props?.large,
  }
  const classes = useStyles(useStylesParams)

  return (
    <>
      <div className={classes.root}>
        <Typography className={classes.title}>{props.title}</Typography>
        <div className={classes.metrics}>
          <Typography className={classes.value}>{props.value}</Typography>
          {props.goal && (
            <div style={{ textAlign: 'right' }}>
              <Typography className={classes.goal}>
                {t('commons.goal')}
              </Typography>
              <Typography className={classes.goal}>{props.goal}</Typography>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default withTranslation()(Metric)
